import type { UserMetadata } from '@/shared/api';
import { clientSortFieldValues } from './filters';
import type { ClientFilterType, ClientSortDirection, ClientSortField } from './filters';

export interface ClientSort {
  sortBy: ClientSortField;
  sortDirection: ClientSortDirection;
}

export type ClientSortChange = Partial<ClientSort> & { tab: ClientFilterType };

type SavedClientSorts = Partial<Record<ClientFilterType, Partial<Record<keyof ClientSort, unknown>>>>;

const sortDirections: readonly ClientSortDirection[] = ['asc', 'desc'];

const oneOf = <T extends string>(values: readonly T[], value: unknown, fallback: T): T =>
  values.includes(value as T) ? (value as T) : fallback;

const savedClientSorts = ({ clientSort }: UserMetadata): SavedClientSorts =>
  typeof clientSort === 'object' && clientSort !== null ? clientSort : {};

export const readClientSort = (metadata: UserMetadata, tab: ClientFilterType): ClientSort => {
  const saved = savedClientSorts(metadata)[tab];
  return {
    sortBy: oneOf(clientSortFieldValues, saved?.sortBy, 'endDate'),
    sortDirection: oneOf(sortDirections, saved?.sortDirection, 'asc'),
  };
};

export const mergeClientSort = (
  metadata: UserMetadata,
  { tab, ...patch }: ClientSortChange
): UserMetadata => ({
  ...metadata,
  clientSort: {
    ...savedClientSorts(metadata),
    [tab]: { ...readClientSort(metadata, tab), ...patch },
  },
});
